import React, { useEffect, useState } from "react";
import { formateDateTime } from "../../utils";
import Avatar from "../../static/images/tia.png";
import { ChatEvents, MessageType, Roles } from "../../constants";
import { createImageFromInitials } from "../../AgentLogo";
import FileIcon from "../../static/images/icon-file.svg";
import DownloadIcon from "../../static/images/icon-download.svg";

import HealthPlanDetails from "./PlanDetails";

function JsonTemplate({
    message,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    ViewPlanDetails,
    ShowPlanFeatures,
}) {

    const [viewMore, setViewMore] = useState(false)

    const content = JSON.parse(message.content);
    useEffect(() => {
        if (content.choices && content.choices.length > 10 && !message.selected) {
            setViewMore(true)
        }
    })
    // console.log(message.displayAllOptions)
    return (
        <>
            {content.type && content.type.toLowerCase() === MessageType.document ?
                <div className="grop_message">
                    <div onClick={() => regenDoc(content.document.docId)} className="download-policy-message message">
                        <div className="download-policy">
                            <img src={FileIcon} className="icon-file" alt="" /><p>Document</p><img src={DownloadIcon} className="icon-download" alt="" />
                        </div>

                    </div>
                </div>
                : null}

            {content.type && content.type.toLowerCase() === "selection" ?
                <>
                    {content.title ? (
                        <div className="grop_message">
                            <div className="message" >
                                <div dangerouslySetInnerHTML={{ __html: content.title }} />
                                <div className="entete">
                                    <h3>{formateDateTime(message.sentAt)}</h3>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {message.selected ? null : (
                        <div className="tabq_wrapper">
                            {content.choices.map((item1, index) => (
                                <>
                                    {message.displayAllOptions || index < 3 || !viewMore ?
                                        <div className="grop_message tabq">
                                            <div onClick={() => selectOption(item1, content.type, message.messageId)} className="question">
                                                {item1.display_value}
                                            </div>
                                        </div>
                                        : null}
                                </>
                            ))}
                            {viewMore && !message.displayAllOptions ?
                                <div className="grop_message tabq">
                                    <div onClick={() => displayAllOptions(message.messageId)} className="question">
                                        {"View More"}
                                    </div>
                                </div>
                                : null}
                        </div>
                    )}
                </>
                : null}
            {content.type && content.type.toLowerCase() === "faq_selection" ?
                <>
                    {content.title ? (
                        <div className="grop_message">
                            <div className="message" >
                                <div dangerouslySetInnerHTML={{ __html: content.title }} />
                                <div className="entete">
                                    <h3>{formateDateTime(message.sentAt)}</h3>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    {message.selected ? null : (
                        <div className="tabq_wrapper">
                            {content.choices.map((item1, index) => (
                                <>
                                    {message.displayAllOptions || index < 3 || !viewMore ?
                                        <div className="grop_message tabq faq">
                                            <div onClick={() => selectOption(item1, content.type, message.messageId)} className="question">
                                                {item1.display_value}
                                            </div>
                                        </div>
                                        : null}
                                </>
                            ))}
                            {viewMore && !message.displayAllOptions ?
                                <div className="grop_message tabq faq more">
                                    <div onClick={() => displayAllOptions(message.messageId)} className="question">
                                        {"View More"}
                                    </div>
                                </div>
                                : null}
                        </div>
                    )}
                </>
                : null}
            {content.type && content.type.toLowerCase() === "plan_multi_selection" ?
                <>
                    {content.title ? (
                        <div className="grop_message">
                            <div className="message" >
                                <div dangerouslySetInnerHTML={{ __html: content.title }} />
                                <div className="entete">
                                    <h3>{formateDateTime(message.sentAt)}</h3>
                                </div>
                            </div>
                        </div>
                    ) : null}

                </>
                : null
            }
            {
                content.type && content.type.toLowerCase() === "plan_selection" ?
                    <>
                        {content.title ? (
                            <div className="grop_message">
                                <div className="message" >
                                    <div dangerouslySetInnerHTML={{ __html: content.title }} />
                                    <div className="entete">
                                        <h3>{formateDateTime(message.sentAt)}</h3>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </>
                    : null
            }
            {
                content.type && content.type === "plan_comparison" ?
                    <div className="tabq_wrapper">
                        <div className="grop_message tabq">
                            <div className="question " onClick={() => showPlansComparison(message.messageId)}>
                                View Comparison
                            </div>
                        </div>
                    </div>
                    : null
            }
            {
                content.type && content.type === "plan_feature" ?
                    <div className="tabq_wrapper">
                        <div className="grop_message tabq">
                            <div className="question " onClick={() => ShowPlanFeatures(message.messageId)}>
                                View Features
                            </div>
                        </div>
                    </div>
                    : null
            }
            {
                content.type && content.type === "list_plans" ?
                    <HealthPlanDetails GAEvent={GAEvent} message={message} ViewPlanDetails={ViewPlanDetails} contactSupport={contactSupport} mainMenu={mainMenu} content={content} ></HealthPlanDetails>
                    : null
            }
            {
                content.type && content.type === "faq" && !message.selected ?
                    <>
                        {content.faq_response ? (
                            <div className="grop_message">
                                <div className="message fullmassage" >
                                    <div dangerouslySetInnerHTML={{ __html: content.faq_response }} />
                                    <div className="entete">
                                        <h3>{formateDateTime(message.sentAt)}</h3>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </>
                    : null
            }
        </>
    );
}

export default function HealthAgentMessage({
    messages,
    agentName,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    AgentMsg,
    ViewPlanDetails,
    ShowPlanFeatures,
}) {
    const formatMessageContent = (message) => {
        try {
            if (!message) return message;
            
            const escapeHtml = (text) => {
                const div = document.createElement('div');
                div.textContent = text;
                return div.innerHTML;
            };
            
            let formattedMessage = escapeHtml(message);
            formattedMessage = formattedMessage.replace(/\n/g, '<br>');
            formattedMessage = formattedMessage.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
            formattedMessage = formattedMessage.replace(
                /https?:\/\/[^\s<]+[^\s<.,;:!?'")]}/g,
                (url) => `<a href="${url}" style="text-decoration: underline;color:grey;" target="_blank" rel="noopener noreferrer">${url}</a>`
            );
            
            return formattedMessage;
        } catch (e) {
            return message;
        }
    }
    return (
        <li className="you">
            {messages.map((item) => (
                <>
                    {item.type.toLowerCase() === "json" ? (
                        <JsonTemplate
                            message={item}
                            displayAllOptions={displayAllOptions}
                            GAEvent={GAEvent}
                            showPlansComparison={showPlansComparison}
                            regenDoc={regenDoc}
                            selectOption={selectOption}
                            contactSupport={contactSupport}
                            mainMenu={mainMenu}
                            AgentMsg={AgentMsg}
                            ViewPlanDetails={ViewPlanDetails}
                            ShowPlanFeatures={ShowPlanFeatures}
                        ></JsonTemplate>
                    ) : (
                        <>
                            {item.type === MessageType.html ? (
                                <div className="grop_message">
                                    <div className="message" >
                                        <div dangerouslySetInnerHTML={{ __html: item.content}} />
                                        <div className="entete">
                                            <h3>{formateDateTime(item.sentAt)}</h3>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="grop_message">
                                    <div className="message">
                                        <div dangerouslySetInnerHTML={{ __html: formatMessageContent(item.content) }} />
                                        <div className="entete">
                                            <h3>{formateDateTime(item.sentAt)}</h3>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                    {/* <div class="spinner"> <div class="bounce1"></div> <div class="bounce2"></div> <div class="bounce3"></div> </div> */}

                    {/* <div className="entete">
                <h3>{formateDateTime(messages[messages.length - 1].sentAt)}</h3>
            </div> */}
                </>
            ))}
            {/* <div className="entete">
                <h3>{formateDateTime(messages[messages.length - 1].sentAt)}</h3>
            </div> */}

        </li>
    );
}
